<template>
    <form class="card" :loading="request_status">
        <h3>Слоты</h3>
        <div class="column" v-if="status == ''">
            <div class="form-item range" v-for="(item, key) in data" :key="key">
                <p>{{ item.start }}</p>
                <span>&ndash;</span>
                <TimeSelect :value.sync="item.end" :id="item.id" @selectUpdate="update"></TimeSelect>
            </div>
        </div>
    </form>
</template>

<script>
    import TimeSelect from '@/components/TimeSelect.vue'

    export default {
        props: ['status', 'data'],
        components: {
            TimeSelect,
        },
        data () {
            return {
                request_status: 'init'
            }
        },
        created () {
            this.$emit('getData')
        },
        methods: {
            update (e) {
                let json = JSON.stringify({id: e.id, end: e.data})
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/parking/' + this.$route.params.id + '/slot', json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((resp) => {
                        this.request_status = ''
                        this.$emit('updateData', resp.data.response)
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.request_status = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            }
        }
    }
</script>